import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserDetailsService {
  private http: HttpClient = inject(HttpClient);

  getUserDetails(): Observable<any> {
    const GET_USER_DETAILS_URL = environment.USER_DETAILS_URL;
    return this.http.get<any>(GET_USER_DETAILS_URL, {
      withCredentials: true
    });
  }
}
